import React from "react";

const experiences = [
  {
    company: "PocketFM",
    role: "Backend Engineer",
    period: "July 2024 - Present",
    description: "Built a marketability prediction system from scratch to evaluate show potential, enabling data-driven investment decisions. Developed a script adaptation tool that automates multilingual script conversion, drastically reducing manual efforts and speeding up content delivery. Optimized an internal utility, cutting memory usage by 15–20%. Automated developer workflows through scripting",
  },
  {
    company: "TechStack Management",
    role: "Backend Developer Intern",
    period: "March 2024 - July 2024",
    description: "Designed and deployed a microservices architecture using FastAPI, improving scalability and modularity. Integrated open-source services to accelerate development and built CI/CD pipelines on AWS to automate deployments and testing workflows.",
  },
  {
    company: "DAO Studio",
    role: "Backend and SRE intern",
    period: "October 2022 - March 2023",
    description: "Developed robust RESTful APIs using Django REST Framework and Flask to facilitate service communication. Dockerized services for consistent deployment and implemented CI/CD pipelines to streamline the release process. Optimized Python codebase, reducing latency by 40%.",
  }
];

const Experience = () => (
  <div>
    <section className="resume-section" id="experience">
      <div className="resume-section-content">
        <h2 className="mb-5">Experience</h2>
        <div className="timeline">
          {experiences.map((exp, idx) => (
            <div className={`timeline-item ${idx % 2 === 0 ? 'left' : 'right'}`} key={idx}>
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <h3 className="mb-0 text-primary">{exp.company}</h3>
                <div className="subheading mb-1">{exp.role}</div>
                <span className="">{exp.period}</span>
                <p>{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    <hr className="m-0" />
  </div>
);

export default Experience; 